import React from 'react';
import { SEOHead } from '../components/SEOHead';
import { Header } from '../Header';
import { Footer } from '../Footer';
import { HeroSection } from './HeroSection';
import { ProblemSection } from './ProblemSection';
import { WhatIsPulseCheckSection } from './WhatIsPulseCheckSection';
import { HowItWorksSection } from './HowItWorksSection';
import { ComparisonSection } from './ComparisonSection';
import { UseCasesSection } from './UseCasesSection';
import { GoDeeperSection } from './GoDeeperSection';
import { AboutSection } from './AboutSection';
import { ContactSection } from './ContactSection';
import { PatientIntelGate, logPatientIntelView } from './PatientIntelGate';

export const PatientIntel = ({ bannerOffset, footerProps, headerProps }) => {
  React.useEffect(() => {
    logPatientIntelView();
  }, []);

  return (
    <>
      <SEOHead
        title="On-Demand Patient Intelligence"
        description="Pulse Checks deliver verified patient intelligence in days. Real Patients has spent a decade building patient communities — now your team can ask and get answers fast."
        url="https://www.realpatients.com/intelligence"
        noIndex={true}
      />
      <Header {...headerProps} bannerOffset={bannerOffset} />
      <main>
        <HeroSection bannerOffset={bannerOffset} />
        <ProblemSection />
        <WhatIsPulseCheckSection />
        <HowItWorksSection />
        <ComparisonSection />
        <UseCasesSection />
        <GoDeeperSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer {...footerProps} />
      <PatientIntelGate />
    </>
  );
};
